var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1.4rem", background: "#fff" } },
    [
      _c("newsTopBox", { attrs: { title: "测试" } }),
      _vm._v(" "),
      _c("div", { staticClass: "banner" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "testBg",
          staticStyle: { "border-top": ".01rem solid #eee" }
        },
        [
          _c("div", { staticClass: "flexBox" }, [
            _c("div", {
              staticClass: "testBgItem t1",
              on: {
                click: function($event) {
                  _vm.to("testList?labelId=" + _vm.scaleLabelList[0].labelId)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "testBgItem t2",
              on: {
                click: function($event) {
                  _vm.to("testList?labelId=" + _vm.scaleLabelList[1].labelId)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flexBox" }, [
            _c("div", {
              staticClass: "testBgItem t3",
              on: {
                click: function($event) {
                  _vm.to("testList?labelId=" + _vm.scaleLabelList[2].labelId)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("footerBox", { attrs: { active: "3" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e43c18bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e43c18bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/test.vue
// module id = null
// module chunks = 